import styled, { createGlobalStyle } from 'styled-components'

export const Wrapper = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 754px;
`

export const MonthHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 16px;
  height: 48px;
  margin-bottom: 8px;
`

export const Navigation = styled.button`
  outline: none;
  background: none;
  border: none;
  cursor: pointer;
`

export const MonthTitle = styled.h2`
  font-family: var(--primary-font);
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: start;
  color: var(--gray-5);
  &:first-letter {
    text-transform: uppercase;
  }
`

export const CalendarStyles = createGlobalStyle`
  .rdp-caption {
    display: none;
  }
  .rdp-table {
    width: 100%;
    .rdp-head_row {
      .rdp-head_cell {
        text-transform: uppercase;
        color: var(--gray-5);
        text-align: center;
        font-family: var(--primary-font);
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }
    .rdp-row {
      .rdp-cell {
        .rdp-day {
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: var(--secondary-font);
          font-size: 16px;
          font-style: normal;
          font-weight: 700;
          line-height: 19.2px;
          margin: 8px auto;
          width: 38px;
          height: 38px;
          border: none;
          background: none;
          outline: none;
          color: var(--gray-5);

          cursor: pointer;

          &.rdp-day_disabled, &.rdp-day_outside {
            color: var(--silver);
            pointer-events: none;
          }
          &.rdp-day_today:not(.rdp-day_selected) {
            border-radius: 100px;
            border: 2px solid var(--cobasi-blue-light-8);
          }

          &.rdp-day_selected {
            border-radius: 100px;
            background: var(--cobasi-blue-light-8);
            color: var(--the-white);
          }

          &.with-campaign:not(.rdp-day_selected) {
            border-radius: 100px;
            background: var(--pale-sky-blue);
          }
        }
      }
    }
  }
`
